export class TipoDeslocamento {
  id: number;
  nome: string;
  sigla: string;
  ativo: boolean;
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/viagens/deslocamento-tipos/deslocamento-tipos.model.ts
 **/